import TimeEntriesContainer from './TimeEntriesContainer';

export default TimeEntriesContainer;
